module.exports = __webpack_public_path__ + "static/oad-f4937cb7ee6261ac78c6dff66ca7d6ef.jpg";